import { z } from 'zod/v3';

// ============================================================================
// Placement Model 스키마
// ============================================================================

/**
 * GNB 네비게이션 바 응답 스키마
 * @see GET /api/market-place/placements/navigation-bars
 */
export const placementNavigationBarSchema = z.object({
  /** ad group ID */
  adGroupId: z.number(),
  /** GNB 카테고리 ID */
  categoryId: z.string().optional(),
  /** GNB 카테고리 명 */
  categoryName: z.string().optional(),
  /** GNB 카테고리 이미지 URL */
  categorySrc: z.string().optional(),
  /** GNB 카테고리 랜딩 링크 */
  categoryUrl: z.string().optional(),
  /** creative ID */
  creativeId: z.number(),
  /** 지면 명 */
  name: z.string().optional(),
  /** GNB 카테고리 Offer Id */
  offerId: z.string().optional(),
  /** GNB 카테고리 Showcase Id */
  showcaseId: z.string().optional(),
});
export type PlacementNavigationBar = z.infer<
  typeof placementNavigationBarSchema
>;
